import { render, staticRenderFns } from "./auth-form.vue?vue&type=template&id=05714f98&scoped=true"
import script from "./auth-form.vue?vue&type=script&lang=js"
export * from "./auth-form.vue?vue&type=script&lang=js"
import style0 from "./auth-form.vue?vue&type=style&index=0&id=05714f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05714f98",
  null
  
)

export default component.exports